import ReactSelect from 'react-select'
import classnames from 'classnames'
import { useState, useRef, useEffect } from 'react'

import { zIndex } from '../../constants'

const getBorderStyles = (state) => {
  if (state.isFocused) return '0.2rem solid var(--primary-color) !important'
  if (state.selectProps.error) return '0.2rem solid var(--alert-color) !important'
  return '0.2rem solid var(--secondary-input-bg) !important'
}

const customStyles = {
  control: (base, state) => ({
    ...base,
    border: getBorderStyles(state),
  }),
}

export default function PrefilledSelect({ error, ...selectProps }) {
  const inputElemRef = useRef()
  const [isEditable, setIsEditable] = useState(false)

  const handleEditClick = () => {
    setIsEditable(true)
  }

  const handleBlur = () => {
    setIsEditable(false)

    selectProps.onBlur && typeof selectProps.onBlur === 'function' && selectProps.onBlur()
  }

  useEffect(() => {
    if (isEditable) {
      inputElemRef.current.focus()
    }
  }, [isEditable])

  return (
    <>
      <div className={classnames('prefilled-select-root flex alignCenter', { error })}>
        <ReactSelect
          classNamePrefix='react-select'
          styles={{ ...customStyles, ...(selectProps.styles || {}) }}
          theme={(theme) => ({
            ...theme,
            colors: { ...theme.colors, primary: 'var(--primary-color)' },
            ...(selectProps.theme || {}),
          })}
          {...selectProps}
          isDisabled={!isEditable}
          ref={inputElemRef}
          onBlur={handleBlur}
        />
        {!isEditable && (
          <button className='edit' onClick={handleEditClick}>
            Edit
          </button>
        )}

        <style jsx>{`
          :global(.react-select__control) {
            width: 100% !important;
            height: 4.2rem !important;
            box-shadow: none !important;
            border-radius: 2.1rem !important;
            font-size: 1.6rem !important;
            background-color: transparent !important;

            &:hover {
              cursor: text !important;
            }
          }

          :global(.react-select__indicator-separator) {
            display: none !important;
          }

          :global(.react-select__option) {
            font-size: 1.6rem !important;
          }

          :global(.react-select__menu) {
            overflow: hidden !important;
            border-radius: 2.1rem !important;
          }

          :global(.react-select__value-container) {
            padding: 0.2rem 1.5rem !important;
          }

          :global(.react-select__placeholder) {
            color: var(--secondary-text-color) !important;
          }

          @media (max-width: 1024px) {
            :global(.react-select__control) {
              min-height: 3.5rem !important;
              height: 3.5rem !important;
              border-radius: 1.8rem !important;
              font-size: 1.4rem !important;
            }

            :global(.react-select__option) {
              font-size: 1.4rem !important;
            }

            :global(.react-select__indicators) {
              height: 100% !important;
            }

            :global(.react-select__menu) {
              overflow: hidden !important;
              border-radius: 1.8rem !important;
            }
          }
          .prefilled-select-root {
            position: relative;
            height: 4.2rem;
            border-radius: 2.1rem;
            background: var(--common-white);
            border: 0.2rem solid var(--secondary-input-bg);

            :global(.select) {
              max-width: 85%;
              flex: 1;
              background: transparent;
              border: none;

              &:focus {
                border-color: var(--primary-color);
                color: #000;
              }

              &::placeholder {
                color: var(--secondary-text-color);
              }
            }

            .edit {
              position: absolute;
              top: 50%;
              right: 1.9rem;
              transform: translate(0, -50%);
              color: var(--primary-color);
              line-height: 2.1rem;
              font-size: 1.6rem;
              background-color: transparent;
            }

            &.error {
              input {
                border-color: var(--alert-color);
              }
            }
          }

          @media (max-width: 1024px) {
            .prefilled-select-root {
              height: 3.5rem;
              border-radius: 1.8rem;

              input {
                font-size: 1.4rem;
              }
            }
          }
        `}</style>
        <style jsx>{`
          :global(.react-select__menu) {
            z-index: ${zIndex.modal};
          }
        `}</style>
      </div>
    </>
  )
}
